import KTWizard from "../../../../../../_metronic/_assets/js/components/wizard";
import KTImageInput from "../../../../../../_metronic/_assets/js/components/image-input";

export function WizardControl(){
    KTWizard("kt_wizard", {});
    KTImageInput("kt_image_5", {});
    return true
}